export default __webpack_public_path__ + "static/media/fsync3.58f9130c.png";